/** 先攻の切り替え（Issue #467）。開始位置が決まっていないときだけ出す（再生タブ・開始前の画面） */
import { playerColor, usePlayerColors } from './common';
import { btn } from './RespondTab';

export default function FirstPlayerPicker({ firstPlayer = 0, players = [], busy = false, disabled = false, onSetFirst }) {
  const colors = usePlayerColors();
  const name = (p) => players?.[p]?.name ?? `P${p + 1}`;
  return (
    <div data-testid="first-player" style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12 }}>
      <span style={{ whiteSpace: 'nowrap' }}>先攻</span>
      {[0, 1].map((p) => (
        <button key={p} type="button" data-testid={`first-player-${p}`} aria-pressed={firstPlayer === p} disabled={busy || disabled || firstPlayer === p}
          onClick={() => onSetFirst?.(p)}
          style={{ ...btn(firstPlayer === p ? 'primary' : 'plain', { grow: true }), borderColor: firstPlayer === p ? playerColor(p, colors) : undefined, opacity: 1 }}>
          {name(p)}（P{p + 1}）
        </button>
      ))}
    </div>
  );
}
